import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import WarrantiesContent from "modules/Warranties";

import React from "react";
import { setTitle } from "utilities/helper/setTitle";

const WarrantiesPage: React.FC = () => {
  setTitle("Warranty Management");
  return (
    <Auth>
      <Layout>
        <WarrantiesContent />
      </Layout>
    </Auth>
  );
};

export default WarrantiesPage;
